﻿export class PWFormatting { }

export const Decimal1Format = {
    type: "fixedPoint",
    precision: 1
}

export const Decimal2Format = {
    type: "fixedPoint",
    precision: 2
}

export const Decimal3Format = {
    type: "fixedPoint",
    precision: 3
}

export const Decimal4Format = {
    type: "fixedPoint",
    precision: 4
}

export const Decimal6Format = {
    type: "fixedPoint",
    precision: 6
}

export const Decimal7Format = {
    type: "fixedPoint",
    precision: 7
}


//product pack size, product units multiplier
export const X1 = "####0.#";

//product molecular weight
export const X2 = "#####.##";

//product humidity
export const X3 = "###.#";

//product estimated batch density, product uncertainty multipler
export const X4 = "0.####";

export const WholeDigitFormat = "#0";


//date formats
export const TimestampToSecondFormat = "MM/dd/yyyy HH:mm:ss";


